import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';

export class ReviewRouteConfig extends RouteConfig {}
